import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('multiSelectPilotField');

    return {
        PILOTS: t('pilots'),
        PILOTS_ARE_REQUIRED: t('pilotsAreRequired')
    };
};

export default useTranslation;
